import React, { useState } from 'react';
import { Box, CardContent, Typography, Modal, Zoom } from '@mui/material';
import ShimmerLoader from '../ShimmerLoader';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import Close from '@mui/icons-material/Close';

const MetricCard = ({ title, value, icon: Icon, change, inc = false, subtitle, chart, loading }) => {
    const [open, setOpen] = useState(false);

    return (
      <>
        <Box
            sx={{
                cursor: "pointer",
                height: '100%',
                borderRadius: '12px',
                border: '1px solid #E5E7EB',
                bgcolor: 'white',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                    transform: 'scale(1.02)',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                    bgcolor: '#F5F5F5',
                }
            }}
            onClick={() => !loading && setOpen(true)}
        >
            <CardContent sx={{ p: 3 }}>
                {/* Title & Icon */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="body2" color="text.primary">
                        {title}
                    </Typography>
                    {Icon && <Icon sx={{ color: 'text.secondary' }} />}
                </Box>

                {/* Value Display */}
                {loading ? (
                    <ShimmerLoader height="47px" />
                ) : (
                    <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {value}
                    </Typography>
                )}

                {/* Change Indicator */}
                {loading ? (
                    <ShimmerLoader height="25px" />
                ) : (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            color: inc ? "success.main" : "error.main"
                        }}
                    >
                        {inc ? <TrendingUpIcon sx={{ fontSize: '25px' }} /> : <TrendingDownIcon sx={{ fontSize: '25px' }} />}
                        <Typography variant="body2" color="text.secondary">
                            <Box component="span">
                                {change}
                            </Box>
                        </Typography>
                    </Box>
                )}
            </CardContent>
        </Box>

        {open && (
            <Modal open={open} onClose={() => setOpen(false)} sx={{outline: "none"}} closeAfterTransition>
            <Zoom in={open}>
            <Box 
                sx={{ 
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh", // Ensures full height for centering
                outline: "none" // Prevents the focus outline
                }}
                > 
              <Box sx={{ width: "100vw", maxWidth: "900px", height: "auto",maxHeight:'600px', bgcolor: "#FFF", padding: "2rem", borderRadius: "8px"}}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center",mb:2}}>
                      <Box>
                          <Typography variant="h6" sx={{ color: "#020429" }}>
                              {title}
                          </Typography>
                          <Typography sx={{ color: "#6A6A6A" }}>
                              {subtitle}
                          </Typography>
                      </Box>
                      <Close onClick={() => setOpen(false)} sx={{ cursor: "pointer" }} />
                  </Box>
                 {/* Chart Rendering Inside the Card */}
                 {loading ? <ShimmerLoader height="300px" /> : chart}
              </Box>
            </Box>
            </Zoom>
          </Modal>
        )}
      </>
    );
};

export default MetricCard;
